const wnd: any = window

export const addGAEvent = (event: any) => {
  window.parent.postMessage({
    topic: 'add-ga-event',
    event: event
  }, '*')
}